import React from 'react';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import Text from '~/components/core/TextComponents/Text';
import { NewRefreshIcon } from '~/components/icons';

interface CounterWithRefreshProps {
  onRefresh?: () => void;
  isLoading?: boolean;
  pagination?: {
    totalCount: number;
    resultsTruncated: boolean;
    page?: number;
    rowsPerPage?: number;
    setPage?: (page: number) => void;
    setRowsPerPage?: (rows: number) => void;
  };
  refreshTooltipText?: string;
  refreshAriaLabel?: string;
  className?: string;
}

const CounterWithRefresh: React.FC<CounterWithRefreshProps> = ({
  onRefresh,
  isLoading,
  pagination,
  refreshTooltipText = 'Refresh',
  refreshAriaLabel = 'Refresh',
  className = 'my-16',
}) => {
  const getLoadingOrNumber = (val: number) => (isLoading ? '-' : val);

  if (pagination?.totalCount === undefined) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Text variant={Text.VARIANTS.LG} weight={Text.WEIGHTS.MEDIUM} className="my-16">
        {`Showing ${getLoadingOrNumber(pagination.totalCount)}${pagination.resultsTruncated ? '+' : ''}`}
      </Text>
      {onRefresh && (
        <IconButton
          title={refreshTooltipText}
          aria-label={refreshAriaLabel}
          className="mb-4 cursor-pointer"
          onClick={onRefresh}
          disabled={isLoading}
        >
          <NewRefreshIcon iconColor="currentColor" className="fill-slate-900 stroke-slate-900" />
        </IconButton>
      )}
    </div>
  );
};

export default CounterWithRefresh;
